// Seção "Anulados na Ampli": lista em leitura dos títulos anulados (credor, documento,
// valor). Fica sempre FORA de qualquer total/lista principal -- quem a usa só a renderiza
// no fim da tela. Valores em REAIS (o BE já manda em reais). Sem <span>: o reset de
// _fonts.scss atinge span dentro de .card.

const brl = (value) => Number(value || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

const AnnulledTitlesList = ({ annulled }) => {
  if (!Array.isArray(annulled) || annulled.length === 0) return null;
  return (
    <section className="annulled-titles margin-top-24" aria-label="Anulados na Ampli">
      <h3>Anulados na Ampli</h3>
      <table>
        <thead>
          <tr>
            <th style={{ textAlign: "left" }}>Credor</th>
            <th style={{ textAlign: "left" }}>Documento</th>
            <th style={{ textAlign: "left" }}>Nº Sienge</th>
            <th style={{ textAlign: "right" }}>A pagar</th>
            <th style={{ textAlign: "right" }}>Pago</th>
          </tr>
        </thead>
        <tbody>
          {annulled.map((t, idx) => (
            <tr key={t.annulmentId ?? `${t.billId}-${idx}`}>
              <td>{t.creditorName || "—"}</td>
              <td>{t.documentType || "—"}</td>
              <td>{t.billId ?? "—"}</td>
              <td style={{ textAlign: "right" }}>{brl(t.removedToPay)}</td>
              <td style={{ textAlign: "right" }}>{brl(t.removedPaid)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
};

export default AnnulledTitlesList;
